import { render, staticRenderFns } from "./GuppyChatVoiceMessage.vue?vue&type=template&id=9eca4770&"
import script from "./GuppyChatVoiceMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatVoiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatVoiceMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports